import { RegisterClass } from "../../../../Misc/typeStore.js";
import { FlowGraphExecutionBlock } from "../../../flowGraphExecutionBlock.js";
export class FlowGraphSequenceBlock extends FlowGraphExecutionBlock {
    constructor(config) {
        super(config);
        this.config = config;
    }
    configure() {
        super.configure();
        this.outFlows = [];
        for (let i = 0; i < this.config.numberOutputFlows; i++) {
            this.outFlows.push(this._registerSignalOutput(`${i}`));
        }
    }
    _execute(context) {
        for (let i = 0; i < this.config.numberOutputFlows; i++) {
            this.outFlows[i]._activateSignal(context);
        }
    }
    getClassName() {
        return FlowGraphSequenceBlock.ClassName;
    }
}
FlowGraphSequenceBlock.ClassName = "FGSequenceBlock";
RegisterClass(FlowGraphSequenceBlock.ClassName, FlowGraphSequenceBlock);
//# sourceMappingURL=flowGraphSequenceBlock.js.map